import React from "react";

interface NumberFormatterProps {
	value: number;
	decimalPlaces?: number;
	currency?: string; // Optional currency symbol (e.g., "$")
}

const NumberDisplay: React.FC<NumberFormatterProps> = ({
	value,
	decimalPlaces = 0,
	currency,
}) => {
	const formattedNumber = new Intl.NumberFormat("en-US", {
		minimumFractionDigits: decimalPlaces,
		maximumFractionDigits: decimalPlaces,
	}).format(value);

	return (
		<span className="font-code font-bold px-2">
			{currency ? `${currency}${formattedNumber}` : formattedNumber}
		</span>
	);
};

export default NumberDisplay;
